enum ConfigKey {
  GRAPHQL_ENDPOINT,
  DATA_SOURCE_UNVERIFIED_BUCKET,
  REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID,
  USER_POOL_DOMAIN,
  IDENTITY_POOL_ID,
  ENVIRONMENT,
  CLOUDFRONT_URL,
  FEDERATED_PROVIDERS
  // add new config keys here ...
}

// Optional config keys that won't cause assertConfigSetup to throw
const optionalConfigKeys: ConfigKey[] = [ConfigKey.FEDERATED_PROVIDERS];

type ConfigKeyString = keyof typeof ConfigKey;

export function getKeys() {
  return Object.keys(ConfigKey).filter(key => isNaN(Number(key)));
}

export function getRequiredKeys() {
  return getKeys().filter(
    key => !optionalConfigKeys.includes(ConfigKey[key as ConfigKeyString])
  );
}

export default ConfigKeyString;
